import { CSSProperties, FC, ReactNode } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './SkeletonBlock.module.scss';

export type SkeletonBlockProps = {
  /** height 0..12 (css: 1px, $size-01, $size-02, ...) */
  size?: number;
  /** border radius: 1..4 (css: $radii-1, $radii-2, ...) */
  rounded?: number;
  /** size (height) is ignored, aspect ratio compared to 100% width */
  aspectRatio?: CSSProperties['aspectRatio'] | number;
  /** grid-column css */
  gridColumn?: CSSProperties['gridColumn'];
  /** grid-row css */
  gridRow?: CSSProperties['gridRow'];
  /** ignore size use children for height */
  children?: ReactNode;
  // if loading then wrap in skeleton, else return children directly
  loading?: boolean;
};

const SkeletonBlock: FC<SkeletonBlockProps> = ({
  size,
  rounded = 1,
  aspectRatio,
  gridColumn,
  gridRow,
  loading = true,
  children,
}) => {
  const custom: CSSProperties = {
    gridColumn,
    gridRow: gridRow || 1,
  };
  if (aspectRatio) {
    custom.aspectRatio = `${aspectRatio}`;
  }

  if (!loading) {
    return children;
  }
  return (
    <div
      className={getClassNames(
        styles,
        'block',
        classNames(
          !aspectRatio ? `size${size}` : false,
          `rounded${rounded}`,
        ),
      )}
      style={custom}
    >
      {/* Add _ if no size specified */}
      {children || !size
        ? (
          <div className={styles.content}>
            {/* Add an _ to take up text space. It is visually hidden */}
            {children || '_'}
          </div>
        )
        : null}
    </div>
  );
};

export default SkeletonBlock;
